import shark1 from "./assets/team1.jpeg";
import shark2 from "./assets/team2.jpeg";
import shark3 from "./assets/team3.jpeg";
import shark4 from "./assets/team4.jpeg";

export const footerData = {
  description: "Smart contract",
  link: "https://etherscan.io/address/0x6409d3A686c2ab9b418Fb3CB5b4778509c5cADd6#code",
};

export const aboutData = {
  title: "What are Happy Sharks?",
  description:
    " The only NFT project with a Tesla giveaway, billboards, and 5 figure donations to give back. Happy Sharks are a unique and exclusive NFT collection consisting of 10,000 programmatically generated shark critters that are living under the sea on the Ethereum blockchain.",
};

export const teamData = {
  title: "OUR TEAM",
  members: [
    {
      name: "Mr. Sharkie",
      designation: "Head of Operations / Marketing",
      image: shark1,
    },
    {
      name: "RonMan",
      designation: "Developer",
      image: shark2,
    },
    {
      name: "Baby Shark",
      designation: "Designer",
      image: shark3,
    },
    {
      name: "ChumBucket",
      designation: "Community Manager / Marketing",
      image: shark4,
    },
  ],
};

export const roadmapData = [
  {
    heading: "0%",
    description:
      "Before we launch minting, a full size billboard will be purchased in a big United States city to promote Happy Shark NFTs. (All early discord server members will get to vote on the design)",
  },
  {
    heading: "20%",
    description:
      "New Bigger Ethereum and Happy Shark NFT Giveaways (more detailing to come)",
  },
  {
    heading: "40%",
    description:
      "A five-figure $ cash donation to a shark/marine life charity voted on by the community (details will be released in discord as well as donation proof).",
  },
  {
    heading: "50%",
    description:
      "Tesla car giveaway to a Happy Shark NFT holder or participator. The coolest part about this is that the Tesla will be wrapped Happy Shark theme!",
  },
  {
    heading: "60%",
    description:
      "An exclusive members-only e-commerce store section opens up our website. An extremely limited quantity of physical clothing will become available to purchase for verified Happy Shark holders only.",
  },
  {
    heading: "80%",
    description: "Happy Shark's first airdrop project for holders is launched.",
  },
  {
    heading: "100%",
    description1:
      'Sharks Cove development begins in full effect: We start the process of building the "Sharks Cove" club platform and release early access information to Happy Shark holders via discord.',
    description2:
      "A limited batch of physical Happy Shark plushies will also be released on our e-commerce store. Yes, you read that right, happy shark plushies!",
  },
];

export const faqData = [
  {
    question: "How much does a Happy Shark cost to mint?",
    answer: "0.05 Ether.",
  },
  {
    question: "How many Happy Sharks can I mint?",
    answer:
      "A maximum of 20 Happy Sharks can be minted per transaction. You can, however, execute as many transactions as you like.",
  },
  {
    question: "What blockchain is this on?",
    answer:
      "This collection of 10,000 Happy Sharks are ERC-721 tokens on the Ethereum blockchain and will be available to freely trade on OpenSea post mint.",
  },
  {
    question: "What is the “Sharks Cove?”?",
    answer:
      "The Sharks Cove is an interactive community type chat platform that allows holders to utilize their NFTs and show them off within the community. Of course there is much more to it, but think of Shark’s Cove as an exclusive members only club, sorta like the platform we are all familiar with called, “Club Penguin”.",
  },
  {
    question: "When is the official drop date?",
    answer: "Minting goes live on Tuesday September 7th at 2:00 PM EST.",
  },
  {
    question: "Will there ever be any giveaways?",
    answer:
      "Absolutely! We have many smaller giveaways planned with prizes consisting of various NFTs and partial crypto coins, to bigger prizes consisting of giving winning real shark teeth and possibly the chance to go cage diving with real sharks!",
  },
  {
    question: "Do you charge an OpenSea commission?",
    answer:
      "We charge a 2.5% commission on OpenSea and OpenSea charges a 2.5% commission on all sales that go to them. Therefore, it adds up to a 5% commission in total. Please see our roadmap for more information on where our commissions will go.",
  },
  {
    question: "What if I have a question that hasn’t been answered here?",
    answer:
      "Swim on over to our Discord, don’t worry the sharks don’t bite. We have a very active community and we’d be happy to answer any questions you may have.",
  },
];

export const mintData = {
  title: "SOLD OUT!",
  description: "If you're late to the launch, you can refer to the ",
  link: "Secondary Market.",
};

export const headerData = {
  socialLinks: {
    twitter: "https://twitter.com/happysharksnft",
    discord: "https://discord.gg/Wpac85dYdF",
    instagram: "https://instagram.com/happysharksnft",
    opensea: "https://opensea.io/collection/happysharks",
  },
  slogan: "YOUR TICKET TO THE NEXT CLUB PENGUIN TYPE PLATFORM: SHARKS COVE",
};
